/*
 * Recolours the "Sign in with Shop" button inside Shopify's account popup.
 * The button lives in the open shadow roots of <shopify-account> and its purple is
 * hard-coded by Shopify, so the theme can't change it with settings — inject a small
 * stylesheet into each <shop-login> shadow root as it appears.
 */
(() => {
  const CSS = `
    .bg-purple-primary { background-color: #E8792B !important; }
    .hover_enabled_bg-purple-d0:hover { background-color: #D4671D !important; }
    .focus_enabled_ring-purple-l1:focus,
    .focus-visible_enabled_ring-purple-l1:focus-visible { --tw-ring-color: rgb(232 121 43 / 0.45) !important; }
    .text-purple-primary { color: #E8792B !important; }
  `;
  let sheet = null;
  const getSheet = () => {
    if (!sheet) {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS);
    }
    return sheet;
  };

  const patch = (root) => {
    for (const el of root.querySelectorAll('*')) {
      if (!el.shadowRoot) continue;
      if (el.tagName === 'SHOP-LOGIN' && !el.shadowRoot.adoptedStyleSheets.includes(getSheet())) {
        el.shadowRoot.adoptedStyleSheets = [...el.shadowRoot.adoptedStyleSheets, getSheet()];
      }
      patch(el.shadowRoot);
    }
  };

  const watch = (account) => {
    const root = account.shadowRoot;
    if (!root || root.__vadoraWatched) return;
    root.__vadoraWatched = true;
    patch(root);
    new MutationObserver(() => patch(root)).observe(root, { childList: true, subtree: true });
  };

  const init = async () => {
    if (!('adoptedStyleSheets' in Document.prototype)) return;
    await customElements.whenDefined('shopify-account');
    const account = document.querySelector('shopify-account');
    if (!account) return;
    // Shadow root is created after the element upgrades.
    let tries = 0;
    const wait = () => {
      if (account.shadowRoot) return watch(account);
      if (++tries < 50) setTimeout(wait, 100);
    };
    wait();
    // Nested shadow roots (shopify-login-form → shop-login) render when the dialog opens.
    account.addEventListener('click', () => setTimeout(() => account.shadowRoot && patch(account.shadowRoot), 400), true);
  };

  init();
})();
